import { ApiMethod } from '@wajeez-web/stores/base';
import {
  thunkErrorHandlerWithoutSdk,
  thunkResponseCheckerSdk,
} from '@wajeez-web/core/utils';
import { contentClient, Server } from '@wajeez-web/core/api-base';

export const openOnboardingContentEntity: ApiMethod<
  Server.OnBoardingGiveOpenContentEntityQuery,
  void,
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandlerWithoutSdk(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Server.Server_Allowings_Client(
          undefined,
          contentClient
        );

        return client.allowings_onboardingOpenContentEntity_post_V1(body);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};
